"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMessageEventBus = void 0;
const eventBus_1 = require("../eventBus");
class PostMessageEventBus extends eventBus_1.EventBusGeneric {
    constructor(eventsMap, availableDomain, listenerWindow = window.top, senderWindow = window.top) {
        super(eventsMap);
        this.eventsMap = eventsMap;
        this.availableDomain = availableDomain;
        this.listenerWindow = listenerWindow;
        this.senderWindow = senderWindow;
        this.listenerWindow = listenerWindow;
        this.senderWindow = senderWindow;
        this.availableDomain = availableDomain;
    }
    getTypes() {
        return Object.keys(this.eventsMap);
    }
    publish(type, event) {
        this.senderWindow.postMessage({ event: this.serialize(event), type }, this.availableDomain);
    }
    subscribe(type, listener) {
        const callback = (serializedEvent) => {
            if (serializedEvent.origin === this.availableDomain && serializedEvent.data.type === type) {
                const MyClass = this.getEventClass(type);
                const event = this.unSerialize(MyClass, serializedEvent.data.event.data, serializedEvent.data.event.eventProperties);
                listener(event);
            }
        };
        this.listenerWindow.addEventListener('message', callback, false);
        return () => this.listenerWindow.removeEventListener('message', callback);
    }
    getEventClass(type) {
        return this.eventsMap[type];
    }
    serialize(event) {
        return {
            data: event.data,
            eventProperties: event.eventProperties,
            nameClass: event.constructor.name,
        };
    }
    unSerialize(EventConfigurableClass, data, eventProperties) {
        return new EventConfigurableClass(data, eventProperties);
    }
}
exports.PostMessageEventBus = PostMessageEventBus;
//# sourceMappingURL=index.js.map